import script from "./OfferedAmountsToValidate.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferedAmountsToValidate.vue?vue&type=script&setup=true&lang=ts"

import "./OfferedAmountsToValidate.vue?vue&type=style&index=0&id=ea4e0fba&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea4e0fba"]])

export default __exports__